'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _IFrameVideoPlayer = require('./IFrameVideoPlayer');

var _IFrameVideoPlayer2 = _interopRequireDefault(_IFrameVideoPlayer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var VideoPlayer = function VideoPlayer(props) {
    var element = props.element,
        dispatchRichMediaReady = props.dispatchRichMediaReady,
        dispatchRichMediaReturnToPreview = props.dispatchRichMediaReturnToPreview,
        dispatchRichMediaError = props.dispatchRichMediaError,
        _props$show = props.show,
        show = _props$show === undefined ? false : _props$show;


    if (!show) return null;

    var videoData = element.getIn(['content', 'media']);

    // At this stage we're only supporting Embedly videos
    return _react2.default.createElement(
        'div',
        { className: 'VideoPlayer' },
        _react2.default.createElement(_IFrameVideoPlayer2.default, { videoData: videoData,
            dispatchRichMediaError: dispatchRichMediaError,
            dispatchRichMediaReturnToPreview: dispatchRichMediaReturnToPreview,
            dispatchRichMediaReady: dispatchRichMediaReady })
    );
};

// Components
// Lib


VideoPlayer.propTypes = {
    element: _propTypes2.default.object.isRequired,
    show: _propTypes2.default.bool,
    render: _propTypes2.default.bool,
    dispatchRichMediaReady: _propTypes2.default.func,
    dispatchRichMediaReturnToPreview: _propTypes2.default.func,
    dispatchRichMediaError: _propTypes2.default.func
};

exports.default = VideoPlayer;


//////////////////
// WEBPACK FOOTER
// ./src/client/element/richMedia/components/video/VideoPlayer.js
// module id = 2018
// module chunks = 0